<template>
  <div>
    <div class="group">
      <label>IP</label>
      <input type="text" v-model="value.ip">
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "XPosSettings",
  props: {
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.createIfMissing(value, 'ip', '0')
      }
    }
  },
  methods: {
    createIfMissing(obj, field, defaultValue) {
      if(obj && !obj[field]) {
        Vue.set(obj, field, defaultValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>